<template>
  <dx-data-grid
      class="grid collapsable"
      :ref="'tasksGrid'"
      :style="`width: 100%; height: 100%; max-height:500px;`"
      :data-source="tasksDataSource"
      :remote-operations="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :show-borders="true"
      :word-wrap-enabled="true"
      :row-alternation-enabled="false"
      :column-auto-width="true"
      @selection-changed="taskSelected"
      @content-ready="contentReady"
      @editor-preparing="overrideOnValueChanged"
  >
    <DxSelection mode="single"/>
    <DxHeaderFilter :visible="false"/>
    <DxFilterRow :visible="true"/>
    <DxLoadPanel :enabled="false"/>
    <DxPaging :page-size="5"/>
    <dx-column
        :filter-operations="['contains']"
        alignment="center"
        data-field="sub_index"
        caption="Sub Component Num"
        width="175"
    />
    <dx-column
        :filter-operations="['contains']"
        alignment="center"
        data-field="c_rh"
        caption="Current RH"
    />
    <dx-column
        :filter-operations="['contains']"
        alignment="center"
        data-field="action"
        caption="M. Action"
    />
    <dx-column
        :filter-operations="['contains']"
        alignment="center"
        data-field="pl_rh"
        caption="Planned RH"
    />
    <dx-column
        :filter-operations="['contains']"
        alignment="center"
        data-field="pr_rh"
        caption="Predicted RH"
    />
    <dx-column
        :filter-operations="['contains']"
        alignment="center"
        data-field="com_rh"
        caption="Completion RH"
    />
    <dx-column
        :allowHeaderFiltering="false"
        :allowFiltering="false"
        :filter-operations="[]"
        alignment="center"
        data-field="verified"
        data-type="boolean"
        caption="Status"
        cell-template="verifiedTemp"
        :minWidth="'160px'"
        :width="'160px'"
        :maxWidth="'160px'"
        :allowSorting="false"
    />
    <div slot="verifiedTemp" slot-scope="{data}">
      <ColorRadioV2
          :id="data.row.data.id"
          :selected="data.row.data.acknowledged"
          :items="status_items"
          :callback="selectStatus"
          :noChange="(data.row.data.completed || (data.row.data.acknowledged > -1 && !data.row.data.pending))"
      />
    </div>

    <DxMasterDetail
        :enabled="false"
        template="detailsTemplate"
    />

    <template #detailsTemplate="{}">
      <v-layout row style="height: 100%">
        <v-flex d-flex md4 style="height: 250px">
          <Chart
              v-bind:chartOptions="createChartForSelectedRow()"
              v-bind:title="'Running Hours'"
              v-bind:active="true"
              v-bind:maximize-callback="maximizeRHGraph"
          />
        </v-flex>
        <v-flex d-flex md4 style="height: 250px">
          <v-card fill-height style="height:100%;width:100%;">
            <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">KPIs</v-card-title>
            <v-card-actions ref="chartContainer" fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;padding-left:1.25rem;">
              <v-layout column style="height: 100%">
                <v-flex md1>
                  <v-layout row>
                    <v-flex md5>Usage Factor:</v-flex>
                    <v-flex md7> {{ (selectedTaskRow.usage_factor||0).toPrecision(2) }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md1>
                  <v-layout row>
                    <v-flex md5>Average Usage Factor (Rolling):</v-flex>
                    <v-flex md7> {{ (selectedTaskRow.usage_factor_rolling||0).toPrecision(2) }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md1>
                  <v-layout row>
                    <v-flex md5>Usage Factor (Diff):</v-flex>
                    <v-flex md7> {{ (selectedTaskRow.usage_factor_rolling_diff||0).toPrecision(2) }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md1>
                  <v-layout row>
                    <v-flex md5>RUL Absolute interval:</v-flex>
                    <v-flex md7> {{ selectedTaskRow.rul_absolute }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md1>
                  <v-layout row>
                    <v-flex md5>RUL Predicted interval:</v-flex>
                    <v-flex md7> {{ selectedTaskRow.rul_predicted }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex d-flex md4 style="height: 250px">
          <v-card fill-height style="height:100%;width:100%;">
            <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Completion details</v-card-title>
            <v-card-actions ref="chartContainer" fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;padding-left:1.25rem;">
              <v-layout column style="height: 100%">
                <v-flex md1>
                  <v-layout row>
                    <v-flex md3>Date:</v-flex>
                    <v-flex md9> -</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md1>
                  <v-layout row>
                    <v-flex md3>Condition:</v-flex>
                    <v-flex md9> -</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md1>
                  <v-layout row>
                    <v-flex md3>Replacement:</v-flex>
                    <v-flex md9> -</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md6>
                  <v-layout row>
                    <v-flex md3>Comment:</v-flex>
                    <v-flex md9> -</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </dx-data-grid>
</template>

<script>

import Chart from '@/components/Chart'
import {DxColumn, DxDataGrid, DxFilterRow, DxHeaderFilter, DxLoadPanel, DxMasterDetail, DxPaging, DxSelection} from "devextreme-vue/data-grid";
import ColorRadioV2 from "@/components/ColorRadioV2";
import LogButton from "@/components/LogButton";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {store} from "@/main";
import axios from "axios";
import TaskDetails from '@/components/cbm/TaskDetails';

export default {
  name: "ComponentTasksTable",
  props: {
    tasksDataSource: Object,
    taskSelected: Object,
    contentReady: Function,
    overrideOnValueChanged: Function,
    createChartForSelectedRow: Function,
    maximizeRHGraph: Function,
    // selectStatus: Function,
    selectedTaskRow: Object,
  },
  data() {
    return {
      status_items: [
        {
          'value': -1,
          'color': 'white',
          'label': 'Pending'
        },
        {
          'value': 0,
          'color': 'red',
          'label': 'Rejected'
        },
        {
          'value': 1,
          'color': 'green',
          'label': 'Approved'
        }
      ],
      updates: {}
    }
  },
  components: {
    Chart,
    DxDataGrid,
    DxLoadPanel,
    DxColumn,
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxMasterDetail,
    DxSelection,
    ColorRadioV2,
    LogButton,
    TaskDetails
  },
  methods: {
    selectStatus: function (id, value) {
      let update_keys = Object.keys(this.updates);

      if (value > -1) {
        this.updates[id] = value
      } else {
        if (update_keys.indexOf(id) > -1) {
          delete this.updates[id];
        }
      }

      this.$emit('update:tasks', this.updates);
      // this.setTasksDataSource(this.selectedTaskRow);
      // this.hasUpdates = Object.keys(this.updates).length > 0;
    },
    getUpdates() {
      console.log(9999)
      return this.updates
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>